// extracted by mini-css-extract-plugin
module.exports = {"global":"layout_global__WnsKI","video":"layout_video__yB0BX","img":"layout_img__vt1qJ"};